// extracted by mini-css-extract-plugin
export default {"sections":"ModuleStatsModal_sections__jBE72","cardList":"ModuleStatsModal_cardList__CwPZu","progress":"ModuleStatsModal_progress__VYc9d","stats":"ModuleStatsModal_stats__0Pnp1"};